import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
import { jsx } from '@emotion/react';
import React from 'react';
import LoadingSkeleton from '../../../../FlexibleCard/components/common/loading-skeleton';
import { CARD_WIDTH_REM } from '../../../styled';
import { getTitleStyles, loadingViewContainer, skeletonContainer, titleBlockStyles } from './styled';
import ActionGroup from '../../../../FlexibleCard/components/blocks/action-group';
import { CustomBlock } from '../../../../FlexibleCard/components/blocks';
import Icon from '../../../../FlexibleCard/components/elements/icon';
const HoverCardLoadingView = ({
  titleBlockProps
}) => {
  const testId = 'hover-card-loading-view';
  const lineHeightRem = 1.25;
  const skeletonWidth = CARD_WIDTH_REM - 2;
  const {
    size,
    actions
  } = titleBlockProps;
  const actionGroup = (actions === null || actions === void 0 ? void 0 : actions.length) && (actions === null || actions === void 0 ? void 0 : actions.length) > 0 && jsx(ActionGroup, {
    items: actions,
    visibleButtonsNum: 2
  });
  return jsx("div", {
    css: loadingViewContainer,
    "data-testid": testId
  }, jsx("div", {
    css: skeletonContainer
  }, jsx(CustomBlock, _extends({}, titleBlockProps, {
    overrideCss: titleBlockStyles,
    testId: `${testId}-title-block`
  }), jsx(Icon, {
    render: () => jsx(LoadingSkeleton, null),
    size: size
  }), jsx("span", {
    css: getTitleStyles(lineHeightRem),
    "data-testid": `${testId}-title`
  }, jsx(LoadingSkeleton, {
    height: lineHeightRem
  })), actionGroup), jsx(LoadingSkeleton, {
    width: skeletonWidth,
    height: lineHeightRem
  }), jsx(LoadingSkeleton, {
    width: skeletonWidth,
    height: lineHeightRem * 3
  }), jsx(LoadingSkeleton, {
    width: skeletonWidth,
    height: lineHeightRem
  })));
};
export default HoverCardLoadingView;